import React, {useRef, useState, useEffect } from "react";
import moment from "moment";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "context/baseUrl/baseUrl";
import { Link, useHistory } from "react-router-dom";
import callWebService, { callTypes } from "services/utils/networks/network";
import { checkEmpty,dateParser } from "services/utils/commonFunctions/CommonFunctions";
import Config from "services/config/config";
import FormSection from "components/form/FormSection";
import Images from "assets/images/imageData";
import DropDownFilter from "components/input/dropdown/dropDownFilter";
import Loader from "components/loader/loader";
import { trim } from "lodash";
import "./MyApplications.scss";
import MainLayout from "components/mainLayout/MainLayout";
import ApplicationBox from "./ApplicationBox";
import DateRangePicker from "./DateRangePicker";

const ApplicationList = ({ match}) => {
  const [smallModal, setSmallModal] = useState({hover1: false, hover2: false, show: false});
  const [activeComponent, setActiveComponent] = useState();
  const [scrollX, setScrollX] = useState(0); // For detecting start scroll postion
  const [scrollEnd, setScrollEnd] = useState(false); // For detecting end of scrolling
  const history = useHistory();
  const scrl = useRef(null);

  const [sortbyClass, setSortByClass] = useState(false);
  const [sortByFilter, setsortByFilter] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [filter, setFilter] = useState("");
  const [dataList, setdataList] = useState([]);
  const [canPreviousPage, setcanPreviousPage] = useState(true);
  const [canNextPage, setcanNextPage] = useState(true);
  const [pagination, setPaginator] = useState({});
  const [showSortBy, setshowSortBy] = useState(false);
  const [descBtn, setDescBtn] = useState(false);
  const [pageNo,setPageNo]=useState(1);
  const [applicationData, setApplicationData] = useState([])
  const [filterFields, setfilterFields] = useState({
    searchName: "",
    searchAppNo: "",
    kycType: "",
    pageNo: 1,
    pageSize: 10 ,
    crmStatus:"",
    searchPennantStatus:"",
    searchFusionsStatus:"",
    searchWebhookStatus:"",
    applicationStatus: "",
    crmApprovalStatus: "",
    breStatus: "",
    creditapprovalstatus: "",
    disbursementApprovalStatus:""
  });
  const {
    course_type,
    course_id,
    kycType,
    crmStatus,
    searchFusionsStatus,
    searchPennantStatus,
    applicationStatus,
    searchWebhookStatus,
    crmApprovalStatus,
    breStatus,
    creditapprovalstatus,
    disbursementApprovalStatus,
    status,
    page,
    sort_by_id,
    sort_by_name,
    sort_by_created_at,
    order_by,
    recordsShown,
    pageSize,
  } = filterFields;
  
  useEffect(()=>{
    (async () => {
      applicationList();
   })();
  },[])

  const truncateText = (text, maxLength = 30) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

  const applicationList = async (filterFields) => {
    setisLoading(true);
    const res = await callWebService(
      callTypes.post,
      filterFields,
      Config.applicationList
    );
    // const {applicationList,pagination} = res?.data?.data;
    if (res?.data?.data?.applicationList === undefined) {
        localStorage.removeItem('logout');
        localStorage.removeItem('loginDate');
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.idToken");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.accessToken");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.refreshToken");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.clockDrift");
        localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.LastAuthUser");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("username");
        history.push('/login');
    }
    if (res?.data?.data?.applicationList) {
        setisLoading(false);
        setApplicationData(res?.data?.data?.applicationList);
        setPaginator(res?.data?.data?.pagination);
    }
  }

  const [disbursementStatusList, setDisbursementStatusList] = useState([
    { statusKey: "approved", statusName: "Approved" },
    { statusKey: "rejected", statusName: "Rejected" },
    { statusKey: "pending", statusName: "Pending" },
    // Add other statuses as per your backend requirements
  ]);

  const [statusList, setStatusList] = useState([
    { status_id: 1, status_name: "Approved" },
    { status_id: 0, status_name: "In Progress" },
    { status_id: 2, status_name: "Rejected" },
    { status_id: 3, status_name: "On Hold" }
  ]);
  const [crmStatusList, setcrmStatusList] = useState([
    { statusKey: 0, statusName: "In Progress" },
    { statusKey: 1, statusName: "Completed" },
    { statusKey: 2, statusName: "Failed" },
    // { statusKey: 3, statusName: "Rejected" },
    // { statusKey: -1, statusName: "NA" }
  ]);

  const [pennantStatusList, setPennantStatusList] = useState([
    { statusKey: 0, statusName: "In Progress" },
    { statusKey: 1, statusName: "Completed" },
    { statusKey: 2, statusName: "Failed" },
    // { statusKey: 3, statusName: "Rejected" },
    // { statusKey: -1, statusName: "NA" }
  ]);
  

  const [CRMStatusList, setCRMStatusList] = useState([
    { crmStatusKey: "rejected", crmStatusName: "Rejected" },
    { crmStatusKey: "approved", crmStatusName: "Approved" },
  ]);

  const [BREStatusList, setBREStatusList] = useState([
    { breStatusKey: "2", breStatusName: "Rejected" },
    { breStatusKey: "1", breStatusName: "Approved" },
  ]);

  const [creditStatusList, setCreditStatusList] = useState([
    { creditStatusKey: "Manual", creditStatusName: "Manual Approved" },
    { creditStatusKey: "Manual Rejected", creditStatusName: "Manual Rejected" }
  ]);

  const [applicationsStatus, setApplicationStatus] = useState([
    { statusKey: 0, statusName: "In Progress" },
    { statusKey: 1, statusName: "Completed" },
    // { statusKey: 2, statusName: "Failed" },
    { statusKey: 3, statusName: "Rejected" },
    { statusKey: 4, statusName: "Disbursed" }
  ])

  const recordsPerPage = [
    {records_id: 10, records_value: 10},
    {records_id: 20, records_value: 20},
    {records_id: 30, records_value: 30},
    {records_id: 50, records_value: 50}
  ];

  const handleDisbursementStatusChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, disbursementApprovalStatus: value }));
  };
  const handleTextInputChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, searchName: value }));
    //setFilter(value);
  };

  const handleIDInputChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, searchAppNo: value }));
  }

  const handleKycInputChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, kycType: value }));
  };

  const handleCrmStatusChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, crmStatus: value }));
  };

  const handleFusionStatusChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, searchFusionsStatus: value }));
  };

  const handlePennantStatusChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, searchPennantStatus: value }));
  }

  const handleApplicationStatusChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, applicationStatus: value }));
  }

  const handleWebhookStatusChange = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, searchWebhookStatus: value }));
  }

  const handleCRMStatus = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, crmApprovalStatus: value }));
  }

  const handleBREStatus = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, breStatus: value }));
  }

  const handleCreditStatus = (e) => {
    const value = e.target.value;
    setfilterFields((state) => ({ ...state, creditapprovalstatus: value }));
  }
  

  const handleAscendingOrder = (e) => {
    let tableData = JSON.parse(JSON.stringify(applicationData));
    if (e.currentTarget.id === "Applicant Name des") {
      setDescBtn(true);
      const sortedData = [...tableData].sort((a, b) =>
        a["applicant_name"]?.toLowerCase() < b["applicant_name"]?.toLowerCase()
          ? -1
          : 1
      );
      const desSort = sortedData.reverse();
      setApplicationData(desSort);
    } else if (e.currentTarget.id === "Applicant Name asc") {
      setDescBtn(false);
      const sortedData = [...tableData].sort((a, b) =>
      a["applicant_name"]?.toLowerCase() < b["applicant_name"]?.toLowerCase()
      ? -1
      : 1
      );
      setApplicationData(sortedData);
    } else if (e.currentTarget.id === "Order Date des") {
      setDescBtn(true);
      const sortedData = [...tableData].sort((a, b) =>
        a["orderdate"].split("T")[0] < b["orderdate"].split("T")[0] ? -1 : 1
      );
      const desSort = sortedData.reverse();
      if (JSON.stringify(desSort) !== JSON.stringify(dataList)) {
        setApplicationData(desSort);
      }
    } else if (e.currentTarget.id === "Order Date asc") {
      setDescBtn(false);
      const sortedData = [...tableData].sort((a, b) =>
        a["orderdate"].split("T")[0] < b["orderdate"].split("T")[0] ? -1 : 1
      );
      if (JSON.stringify(sortedData) !== JSON.stringify(dataList)) {
        setApplicationData(sortedData);
      }
    }
  }

  const changeStatusText = (data, kycData) => {
    let statusName;
    if (data == 0) {
      statusName = 'In Progress';
    } else if (data == 1) {
      statusName = kycData === 'kycStatus' ? 'Approved' : 'Complete';
    } else if (data == 2) {
      statusName = kycData === 'kycStatus' ? 'Rejected' : 'Failed';
    } else if (data === 3 && kycData === 'kycStatus') {
      statusName = "On Hold";
    }
    else if (data === 4 && kycData === 'kycStatus') {
      statusName = "Disbursed";
    }
    return statusName;
  } 

  const changePenantStatusText = (pennantStatus, fusionApprovalStatus) => {
    let statusName;
    // if (fusionApprovalStatus == 2) {    
    //   return statusName = "NA";
    // }
    if (pennantStatus == -1) {    
      return statusName = "NA";
    } else   if (pennantStatus == -2) {    
      return statusName = "";
    }
    if (pennantStatus == 0) {
      statusName = 'In Progress';
    } else if (pennantStatus == 1) {
      statusName = 'Complete';
    } else if (pennantStatus == 2) {
      statusName = 'Failed';
    } else if (pennantStatus === 3) {
      // statusName = "On Hold";
      statusName = "Rejected";
    }
    else if (pennantStatus === 4) {
      // statusName = "On Hold";
      statusName = "Disbursed";
    }
    return statusName;
  }


  const changeConditionText = (crmStatus, fusionStatus, pennantStatus, status) => {
    let statusName;
    if (pennantStatus == 2 || fusionStatus == 2 || crmStatus == 2) {
      statusName = 'Failed';
    } else if (crmStatus == 1 && fusionStatus == 1 && pennantStatus == 1) {
      statusName = 'Complete';
    } else if (pennantStatus == 0 || fusionStatus == 0 || crmStatus == 0) {
      statusName = 'In Progress';
    }    
    return statusName;
  }

  const statusText = (status) => {
    let statusName;
    if (status == -1) {    
      return statusName = "NA";
    } else if (status == -2) {    
      return statusName = "Not Started";
    } 
    if (["", "0"].includes(status)) {
      statusName = "In Progress";
    } else if ( status == "1") {
      statusName = 'Complete';
    } else if (status == "2") {
      statusName = 'Failed';
    } else if (status == "3") {
      statusName = 'Rejected';
    }else if (status == "4") {
      statusName = 'Disbursed';
    }
    return statusName;
  }
  

  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Application Number",
      "DA Application Number",
      "Applicant Name",
      "Mobile Number",
      "Partner Name",
      "Institute Name",
      "Institute Course Details",
      "BRE status",
      "Credit Status",
      "KYC Status",
      "Primary CIF Number",
      "LAN Number",
      "API Status",
      "Lead Status",
      "Disbursement Status",
      "Lead Creation Date",
      "UTR Number",
      "UTR Date",
      "Remark",
      "Action"
    ];

    return headerElement.map((key, index) => {
        return <th style={{textAlign:"left"}} key={index}>{key}</th>;
    });
  };

  const handleOrder = (data) => {
    const check={
      kycType : filterFields?.kycType,
      pageNo: 1,
      pageSize: 10,
      searchAppNo: trim(filterFields?.searchAppNo),
      searchName: trim(filterFields?.searchName),
      crmStatus: filterFields?.crmStatus,
      searchPennantStatus:filterFields?.searchPennantStatus,
      searchFusionsStatus:filterFields?.searchFusionsStatus,
      searchWebhookStatus:filterFields?.searchWebhookStatus,
      applicationStatus: filterFields?.applicationStatus,
      crmApprovalStatus: filterFields?.crmApprovalStatus,
      breStatus: filterFields?.breStatus,
      creditapprovalstatus: filterFields?.creditapprovalstatus,
      disbursementApprovalStatus: filterFields?.disbursementApprovalStatus

    };
    setPageNo(1);
    // handleFilterSearch(check);
  }

  const handSearch= () =>{
    const check={
      kycType : filterFields?.kycType,
      pageNo: 1,
      pageSize: 10,
      searchAppNo: trim(filterFields?.searchAppNo),
      searchName: trim(filterFields?.searchName),
      crmStatus: filterFields?.crmStatus,
      searchPennantStatus:filterFields?.searchPennantStatus,
      searchFusionsStatus:filterFields?.searchFusionsStatus,
      searchWebhookStatus:filterFields?.searchWebhookStatus,
      applicationStatus: filterFields?.applicationStatus,
      crmApprovalStatus: filterFields?.crmApprovalStatus,
      breStatus: filterFields?.breStatus,
      creditapprovalstatus: filterFields?.creditapprovalstatus,
      disbursementApprovalStatus: filterFields?.disbursementApprovalStatus

    };
    setPageNo(1);
    handleFilterSearch(check);
  }

  const handleRecordsPerPage = (pageSize) => {
    setfilterFields((state) => ({...state, pageNo: 1, pageSize: parseInt(pageSize)}))
    const check={
      kycType : filterFields?.kycType,
      pageNo: 1,
      pageSize: parseInt(pageSize),
      searchAppNo: filterFields?.searchAppNo,
      searchName: filterFields?.searchName,
      crmStatus: filterFields?.crmStatus,
      searchPennantStatus:filterFields?.searchPennantStatus,
      searchFusionsStatus:filterFields?.searchFusionsStatus,
      searchWebhookStatus:filterFields?.searchWebhookStatus,
      applicationStatus: filterFields?.applicationStatus,
      crmApprovalStatus: filterFields?.crmApprovalStatus,
      breStatus: filterFields?.breStatus,
      creditapprovalstatus: filterFields?.creditapprovalstatus,
      disbursementApprovalStatus: filterFields?.disbursementApprovalStatus
    };
    setPageNo(1);
    handleFilterSearch(check);
  };

  const capitalizeStatus = (str) => {
      if (str) {
        return str?.charAt(0).toUpperCase() + str?.slice(1);
      }
    }

  const renderBody = () => {
    return (
      !checkEmpty(applicationData) && 
      
      applicationData.map((val, index) => {
        return (
          <tr key={index}>
            <td>{pageNo === 1 ? index + 1 : (pageNo - 1) * pageSize + index + 1 }</td>
            <td>{val.partner_application_no}</td>
            <td>{val.application_no ?? ''}</td>
            <td className="leftAlign">{val.applicant_name}</td>
            <td>{val.mobile_number ?? ''}</td>
            <td>{val.partner_name}</td>
            <td className="truncated-column" title={val.institute_name}>
            {truncateText(val.institute_name, 30)}
            </td>
            <td className="truncated-column" title={val.institute_course}>
              {truncateText(val.institute_course, 30)}
            </td>
            <td>{val.bre_approval_status}</td>
            <td>{val.credit_approval_status == "Manual" ? "Manual Approved" : val.credit_approval_status == "-1" ? "" : val.credit_approval_status}</td>
            <td>{changeStatusText(val.fusion_approval_status, 'kycStatus')}</td>
            <td>{val.primary_cif}</td>
            <td>{val.lan_number}</td>
            <td>{changePenantStatusText(val.pennant_status, val.fusion_approval_status)}</td>
            <td>{statusText(val.status)}</td>
            <td>{val.disbursement_approval_status && val.disbursement_approval_status.charAt(0).toUpperCase() + val.disbursement_approval_status.slice(1)}</td>
            <td>{val.created_at?dateParser(val.created_at,"MM-DD-YYYY"):null}</td>
            {/* <td>{val.orderdate?dateParser(val.orderdate,"MM-DD-YYYY"):null}</td> */}
            <td>{val.utr_number ?? ''}</td>
            <td>{val.utrdate?dateParser(val.utrdate,"MM-DD-YYYY"):null}</td>
            <td>{val.application_remark}</td>
            <td>
              <Link
                to={{
                  pathname: `/application-details/${val.application_no}`
                }}
              >
                <img src={Images?.eyeIcon} alt="" width={20}/>
              </Link>
            </td>
          </tr>
        );
      })
    );
  };
  const nextPage = () => {
    setcanPreviousPage(true);
    setfilterFields(state => ({...state, pageNo: state.pageNo + 1}));
    const check={
      kycType : filterFields?.kycType,
      pageNo: pageNo + 1,
      pageSize: pageSize,
      searchAppNo: filterFields?.searchAppNo,
      searchName: filterFields?.searchName,
      crmStatus: filterFields?.crmStatus,
      searchPennantStatus:filterFields?.searchPennantStatus,
      searchFusionsStatus:filterFields?.searchFusionsStatus,
      searchWebhookStatus:filterFields?.searchWebhookStatus,
      applicationStatus: filterFields?.applicationStatus,
      crmApprovalStatus: filterFields?.crmApprovalStatus,
      breStatus: filterFields?.breStatus,
      creditapprovalstatus: filterFields?.creditapprovalstatus,
      disbursementApprovalStatus: filterFields?.disbursementApprovalStatus,
    };
    setPageNo(pageNo + 1);
     handleFilterSearch(check);
  };
  const previousPage = () => {
    if(pageNo>=1){
      const check={
        kycType : filterFields?.kycType,
        pageNo: pageNo - 1,
        pageSize: pageSize,
        searchAppNo: filterFields?.searchAppNo,
        searchName: filterFields?.searchName,
        crmStatus: filterFields?.crmStatus,
        searchPennantStatus:filterFields?.searchPennantStatus,
        searchFusionsStatus:filterFields?.searchFusionsStatus,
        searchWebhookStatus:filterFields?.searchWebhookStatus,
        applicationStatus: filterFields?.applicationStatus,
        crmApprovalStatus: filterFields?.crmApprovalStatus,
        breStatus: filterFields?.breStatus,
        creditapprovalstatus: filterFields?.creditapprovalstatus,
        disbursementApprovalStatus: filterFields?.disbursementApprovalStatus
      };
      setPageNo(pageNo > 1 ? pageNo - 1 : 1);
      handleFilterSearch(check);
    }  
  };
  const gotoPage = (param) => {
    const check={
      kycType : filterFields?.kycType,
      pageNo: param,
      pageSize: pageSize,
      searchAppNo: filterFields?.searchAppNo,
      searchName: filterFields?.searchName,
      crmStatus: filterFields?.crmStatus,
      searchPennantStatus:filterFields?.searchPennantStatus,
      searchFusionsStatus:filterFields?.searchFusionsStatus,
      searchWebhookStatus:filterFields?.searchWebhookStatus,
      applicationStatus: filterFields?.applicationStatus,
      disbursementApprovalStatus: filterFields?.disbursementApprovalStatus
    };
    setPageNo(param);
    handleFilterSearch(check);
  };
  const inputSearch = () => {
    return (
      <div style={{display: "inline-block"}}>
         <input
          type="text"
          className="search-button"
          onChange={handleIDInputChange}
          name="search"
          placeholder="App./DA/CRM ID"
          autoComplete="off"
        />&nbsp;
        <input
          type="text"
          className="search-button"
          onChange={handleTextInputChange}
          name="search"
          placeholder="Applicant/Partner Name/LAN No"
        />    
         {/* &nbsp;<div className="dropdown1" style={{float: "none"}}>
          <DropDownFilter
            value={crmApprovalStatus}
            name="crmApprovalStatus"
            optionList={CRMStatusList}
            optIdKey="crmStatusKey"
            optValueKey="crmStatusName"
            id="crmApprovalStatus"
            placeholder="Product Verification Status"
            onChange={handleCRMStatus}
          />
        </div>    */}
        &nbsp;<div className="dropdown1" style={{float: "none"}}>
          <DropDownFilter
            value={breStatus}
            name="breStatus"
            optionList={BREStatusList}
            optIdKey="breStatusKey"
            optValueKey="breStatusName"
            id="breStatus"
            placeholder="BRE Status"
            onChange={handleBREStatus}
          />
        </div>
        &nbsp;<div className="dropdown1" style={{float: "none"}}>
          <DropDownFilter
            value={creditapprovalstatus}
            name="creditapprovalstatus"
            optionList={creditStatusList}
            optIdKey="creditStatusKey"
            optValueKey="creditStatusName"
            id="creditapprovalstatus"
            placeholder="Credit Status"
            onChange={handleCreditStatus}
          />
        </div>
        
        &nbsp;<div className="dropdown1" style={{float: "none"}}>
      <DropDownFilter
        value={disbursementApprovalStatus} // CHANGED
        name="disbursementApprovalStatus" // CHANGED
        optionList={disbursementStatusList} // CHANGED to use appropriate status list
        optIdKey="statusKey"
        optValueKey="statusName"
        id="disbursementApprovalStatus" // CHANGED
        placeholder="Disbursement Status"
        onChange={handleDisbursementStatusChange} // CHANGED
      />
    </div>

        &nbsp;<div className="dropdown1" style={{float: "none"}}>
          <DropDownFilter
            value={kycType}
            name="kycType"
            optionList={statusList}
            optIdKey="status_id"
            optValueKey="status_name"
            id="kycType"
            placeholder={localization.placeholders.kycStatus}
            onChange={handleKycInputChange}
          />
        </div>
        &nbsp;<div className="dropdown1" style={{float: "none"}}>
          <DropDownFilter
            value={searchFusionsStatus}
            name="searchFusionsStatus"
            optionList={crmStatusList}
            optIdKey="statusKey"
            optValueKey="statusName"
            placeholder="Fusion Status"
            onChange={handleFusionStatusChange}
          />
        </div>
        &nbsp;<div className="dropdown1" style={{float: "none"}}>
          <DropDownFilter
            value={searchPennantStatus}
            name="searchPennantStatus"
            // optionList={crmStatusList}
            optionList={pennantStatusList}
            optIdKey="statusKey"
            optValueKey="statusName"
            placeholder="API Status"
            onChange={handlePennantStatusChange}
          />
        </div>
        &nbsp;<div className="dropdown1" style={{float: "none"}}>
          <DropDownFilter
            value={applicationStatus}
            name="searchApplicationStatus"
            optionList={applicationsStatus}
            optIdKey="statusKey"
            optValueKey="statusName"
            placeholder="Lead Status"
            onChange={handleApplicationStatusChange}
          />
        </div>
        &nbsp;<button className="btn btn-primary" onClick={handSearch}>Search</button>
        &nbsp;<button className="btn btn-warning" onClick={() =>document.location.reload()}>Reset</button>
        <DateRangePicker />
        <div className="applications-pagination-area">
        {applicationData && applicationData.length > 0 ?
          <span className="pagination-value" data-hovered={smallModal.hover1} style={{cursor: 'pointer', position: 'relative'}} onMouseLeave={() => {
            setSmallModal({...smallModal, hover1: false, hover2: false});
          }} onMouseEnter={() => {
            setSmallModal({...smallModal, hover1: true, show: true});
          }}>
            {pageNo === 1 ? 1 : pagination.current_page + 1} - {pageNo * pageSize > pagination.total_rows ? pagination.total_rows : pageNo * pageSize} of {pagination.total_rows}
            {(smallModal.hover1) && <div className="small-modal applications-small-modal" onMouseEnter={() => {
            setSmallModal({...smallModal, hover2: true})
          }} onMouseLeave={() => {
            setSmallModal({...smallModal, hover2: false, hover1: false});
          }}>
              <span className="small-modal-option" data-disabled={pageNo === 1 && true} onClick={() => {
                gotoPage(1);
              }}>Newest</span>
              <span className="small-modal-option" data-disabled={pageNo * pageSize >= Number(pagination.total_rows) && true} onClick={() => {
                gotoPage(Math.ceil(Number(pagination.total_rows)/ pageSize));
              }}>Oldest</span>
            </div>}
          </span>
          : <span className="pagination-value">0 - 0 of 0</span>}
          <button
                  className="pagination-button"
                  onClick={() => previousPage()}
                  data-disabled={pageNo === 1 && true}
                  disabled={pageNo <= 1}
          >
            {"<"}
          </button>
          <button
            className="pagination-button"
            onClick={() => nextPage()}
            data-disabled={pageNo * pageSize >= Number(pagination.total_rows) && true}
            disabled={pageNo >= Math.ceil(Number(pagination.total_rows ? pagination.total_rows : 0)/10)}
          >
            {">"}
          </button>
        </div>
      </div>
    );
  };



  const [showModal, setShowModal] = useState(false);

  const handleFilterSearch = async (filterFields) => {
    setisLoading(true);
    applicationList(filterFields)
    setisLoading(false);
    setShowModal(false);
    setshowSortBy(false);
  };

  const scrollCheck = () => {
    setScrollX(scrl.current.scrollLeft);
    if (Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <= scrl.current.offsetWidth) {
      setScrollEnd(true);
    } else {
      setScrollEnd(false);
    }
  }

  const filterSearch = () => {};

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout
        activeComponent={activeComponent}
        match={match}
      >
        <Layout
          title={localization.allApplications}
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          <FormSection
            search={true}
            inputSearch={inputSearch}
            filterSearch={filterSearch}
            sortBy={() => {}}
            isCheck={isCheck}
          >
            <div className="panel-card-table" ref={scrl} onScroll={scrollCheck} style={{width: "100%", overflow: "auto"}}>

              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>
                  {renderBody()}
                </tbody>
              </table>
            </div>
          </FormSection>
          <div className="pagination">
            <div className="records-per-page-dropdown">
            <DropDownFilter 
                  optIdKey="records_id"
                  optValueKey="records_value"
                  optionList={recordsPerPage}
                  placeholder="Records Per Page"
                  onChange={(event) => {
                    handleRecordsPerPage(event.target.value);
                  }}
                  value={pagination.pre_page_records}
             />
            </div>
          </div>
          <Loader isLoading={isLoading} />
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap">
            {!checkEmpty(dataList) &&
              dataList.map((data, index) => (
                <ApplicationBox data={data} key={index} history={history} />
              ))}
          </div>
        </div>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default ApplicationList;